import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ContentBlock } from '../../models';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-cta',
  templateUrl: './content-block-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockCtaComponent extends ContentBlockBaseComponent implements OnInit {
  ngOnInit(): void {
    this.fixedTheme = this.block?.hasDarkTheme ? 'dark' : undefined;
  }
}
